var map = {
	"./DOC.png": "0fac",
	"./EXCEL.png": "69f5",
	"./OTHER.png": "03da",
	"./PDF.png": "28f8",
	"./PIC.png": "54f6",
	"./PPT.png": "20a2",
	"./VIDEO.png": "fb39",
	"./VOICE.png": "cb1a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d9c8";